import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import {
  Field,
  reduxForm,
  change,
  submit,
  untouch,
  isValid,
  registerField,
  formValueSelector,
  getFormSubmitErrors,
} from 'redux-form'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import { TextField, Checkbox } from 'redux-form-material-ui'
import { themeColors } from '../styles/theme'
import RaisedButton from 'material-ui/RaisedButton'
import Paper from 'material-ui/Paper'
import CheckBoxIcon from 'material-ui/svg-icons/toggle/check-box'
import { Row, Col } from 'pui-react-grids'
import FontIcon from 'material-ui/FontIcon'
import { required, email, accepted } from '../form/validation'
import { Link } from 'react-router-dom'
import { fbLoginAndMe, unloadFbLoginAndMe } from '../actions'
import { getFbData } from '../selectors'

const generateUsernameFromName = name => {
  let username = name.replace(/[^a-z ]/gi, '')
  username = username.replace(' ', '.')
  username = username.toLowerCase() + '.' + Math.floor(Math.random() * 10000)
  return username
}

const styles = {
  containerStyle: {
    paddingLeft: 10,
    paddingRight: 10,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    color: themeColors.positive,
    textTransform: 'uppercase',
  },
  subTitle: {
    marginBottom: 0,
    width: 256,
    marginTop: 0,
  },
  inputsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 30,
  },
  titleIcon: {
    fill: themeColors.positive,
    position: 'relative',
    top: 5,
    marginRight: 5,
  },
  button: {
    marginTop: 20,
    marginRight: 10,
  },
  labelStyle: {
    fontSize: 12.5,
  },
  facebookBtn: {
    marginBottom: 10,
  },
  bottom: {
    marginTop: 20,
    marginBottom: 20,
  },
  formGroup: {
    height: 75,
    display: 'flex',
    justifyContent: 'center',
  },
  accceptTermsContainer: {
    display: 'inline-flex',
    // justifyContent: 'center',
    marginTop: 20,
  },
  smallText: {
    fontSize: 12,
    color: themeColors.darkBlack,
    marginBottom: 0,
    marginTop: 0,
  },
  // TODO: Make a component or something this shit came from login page
  errorMessage: {
    // Fuck off...
    width: 256,
    padding: 10,
    fontWeight: 'bold',
    color: themeColors.secondary,
    backgroundColor: themeColors.lightBackground,
    borderRadius: 4,
  },
  errorIcon: {
    position: 'relative',
    top: 5,
    right: 4,
    color: themeColors.secondary,
  },
}

const validate = values => {
  const errors = {}

  if (
    values.email && values.emailRepeat && values.email !== values.emailRepeat
  ) {
    errors['emailRepeat'] = 'Le due email non combaciano'
  }

  return errors
}

class RegisterForm extends PureComponent {
  state = {
    showConfirmationFb: false,
  }

  componentDidMount() {
    // Illegal life watch police on bikes
    this.props.registerField('registration-form', 'facebookId', 'Field')
    this.props.registerField(
      'registration-form',
      'facebookAccessToken',
      'Field'
    )
    this.props.registerField('registration-form', 'signUpWith', 'Field')
    this.props.registerField('registration-form', 'generatedUsername', 'Field')
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.fbData !== nextProps.fbData && nextProps.fbData) {
      const username = generateUsernameFromName(nextProps.fbData.me.name)
      this.props.change('registration-form', 'signUpWith', 'facebook')
      // Populate facebook shit...
      this.props.change('registration-form', 'username', username)
      this.props.change('registration-form', 'email', nextProps.fbData.me.email)
      this.props.change('registration-form', 'generatedUsername', username)
      this.props.change(
        'registration-form',
        'facebookId',
        nextProps.fbData.me.id
      )
      this.props.change(
        'registration-form',
        'facebookAccessToken',
        nextProps.fbData.login.accessToken
      )
    }
  }

  componentWillUnmount() {
    this.props.unloadFbLoginAndMe()
  }

  chooseSignUpWithEmail = () => {
    this.props.unloadFbLoginAndMe()
    this.props.change('registration-form', 'signUpWith', 'email')
    // Clear email form fields....
    this.props.change('registration-form', 'username', '')
    this.props.change('registration-form', 'password', '')
    this.props.change('registration-form', 'email', '')
    this.props.change('registration-form', 'emailRepeat', '')
    this.props.untouch('registration-form', 'username')
    this.props.untouch('registration-form', 'password')
    this.props.untouch('registration-form', 'email')
    this.props.untouch('registration-form', 'emailRepeat')
  }

  undoSignUpWithEmail = () => {
    this.props.change('registration-form', 'signUpWith', null)
  }

  undoSignUpWithEmailFromFacebook = () => {
    this.props.unloadFbLoginAndMe()
    this.props.change('registration-form', 'signUpWith', null)
  }

  confirmBeforeSignUpWithFacebook = () => {
    if (
      this.props.isValid && this.props.username === this.props.generatedUsername
    ) {
      this.setState({ showConfirmationFb: true })
    } else {
      this.props.submit('registration-form')
    }
  }

  handleCloseFbConfirmation = () => {
    this.setState({ showConfirmationFb: false })
  }

  render() {
    const {
      handleSubmit,
      submitting,
      submit,
      signUpWith,
      error,
      submitErrors,
    } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <Paper style={styles.containerStyle}>
          <h3 style={styles.title}>
            <CheckBoxIcon style={styles.titleIcon} />Registrazione
          </h3>
          <p style={styles.subTitle}>
            {!signUpWith && 'Scegli un metodo di registrazione:'}
            {signUpWith === 'facebook' &&
              'Verrà utilizzato come "Nome Utente" il tuo nome su Facebook, se vuoi cambiarlo modificalo qui:'}
            {signUpWith === 'email' &&
              'Compila questo form per creare un account su Swapick.'}
          </p>

          {/* Choose registration method */}
          {!signUpWith &&
            <div style={{ textAlign: 'center' }}>
              <div>
                <RaisedButton
                  label="Registrati con email"
                  labelStyle={styles.labelStyle}
                  onClick={this.chooseSignUpWithEmail}
                  style={styles.button}
                  labelColor={themeColors.white}
                  primary={true}
                />
              </div>
              <p>Oppure</p>
              <RaisedButton
                disabled={submitting}
                onClick={this.props.fbLoginAndMe}
                type="button"
                label="Registrati con facebook"
                backgroundColor="#3B5998"
                style={styles.facebookBtn}
                labelColor={themeColors.white}
                labelStyle={styles.labelStyle}
                icon={
                  <FontIcon
                    className="fa fa-facebook"
                    style={{ color: themeColors.white }}
                  />
                }
              />
            </div>}

          {/* Email registration  */}
          {signUpWith === 'email' &&
            <div>
              <div>
                <div style={styles.formGroup}>
                  <Field
                    name="username"
                    component={TextField}
                    validate={[required]}
                    hintText="Nome Utente"
                    floatingLabelText="Nome Utente"
                  />
                </div>
                <div style={styles.formGroup}>
                  <Field
                    name="password"
                    type="password"
                    component={TextField}
                    validate={[required]}
                    hintText="Password"
                    floatingLabelText="Password"
                  />
                </div>
                <div style={styles.formGroup}>
                  <Field
                    name="email"
                    type="email"
                    validate={[required, email]}
                    component={TextField}
                    hintText="Indirizzo mail"
                    floatingLabelText="Indirizzo mail"
                  />
                </div>
                <div style={styles.formGroup}>
                  <Field
                    name="emailRepeat"
                    type="email"
                    validate={[required, email]}
                    component={TextField}
                    hintText="Ripeti indirizzo mail"
                    floatingLabelText="Ripeti indirizzo mail"
                  />
                </div>
              </div>

              <div
                style={styles.accceptTermsContainer}
                className="ressponsive-text">
                <Field
                  name="acceptTerms"
                  component={Checkbox}
                  validate={[accepted]}
                  label="Accetto"
                  style={{ width: 'none' }}
                />
                <Link
                  to="https://about.swapick.com/termini-e-condizioni-duso"
                  target="_blank"
                  style={{ color: themeColors.positive, marginLeft: 4 }}>
                  termini e condizioni
                </Link>
              </div>

              <div style={{ textAlign: 'center' }}>
                <RaisedButton
                  disabled={submitting}
                  onClick={this.undoSignUpWithEmail}
                  label="Annulla"
                  secondary={true}
                  style={styles.button}
                />
                <RaisedButton
                  type="submit"
                  disabled={submitting}
                  label={'Registrati'}
                  primary={true}
                  style={styles.button}
                />
                <p style={{ opacity: submitting ? 1 : 0, marginBottom: 0 }}>
                  Registrazione in corso...
                </p>
              </div>
            </div>}

          {signUpWith === 'facebook' &&
            <div>
              <div style={styles.formGroup}>
                <Field
                  name="username"
                  component={TextField}
                  validate={[required]}
                  hintText="Nome Utente"
                  floatingLabelText="Nome Utente"
                />
              </div>
              <div
                style={styles.accceptTermsContainer}
                className="ressponsive-text">
                <Field
                  name="acceptTerms"
                  component={Checkbox}
                  validate={[accepted]}
                  label="Accetto"
                  style={{ width: 'none' }}
                />
                <Link
                  to="https://about.swapick.com/termini-e-condizioni-duso"
                  target="_blank"
                  style={{ color: themeColors.positive, marginLeft: 4 }}>
                  termini e condizioni
                </Link>
              </div>
              <div style={{ textAlign: 'center' }}>
                <RaisedButton
                  disabled={submitting}
                  onClick={this.undoSignUpWithEmailFromFacebook}
                  label="Annulla"
                  secondary={true}
                  style={styles.button}
                />
                <RaisedButton
                  onClick={this.confirmBeforeSignUpWithFacebook}
                  disabled={submitting}
                  label={'Registrati'}
                  primary={true}
                  style={styles.button}
                />
                <p style={{ opacity: submitting ? 1 : 0, marginBottom: 0 }}>
                  Registrazione in corso...
                </p>
              </div>
              {!!((submitErrors && submitErrors.email) || error) &&
                <div style={styles.errorMessage}>
                  <FontIcon style={styles.errorIcon} className="material-icons">
                    report_problem
                  </FontIcon>
                  Errore durante la registrazione.
                  {submitErrors &&
                    submitErrors.email &&
                    ` ${submitErrors.email}`}
                </div>}
            </div>}

          <Dialog
            title="Conferma registrazione"
            actions={[
              <FlatButton
                label="Annulla"
                primary={true}
                onClick={this.handleCloseFbConfirmation}
              />,
              <FlatButton
                label="Conferma"
                primary={true}
                onClick={() => {
                  this.handleCloseFbConfirmation()
                  this.props.submit('registration-form')
                }}
              />,
            ]}
            modal={true}
            open={this.state.showConfirmationFb}>
            Verrà utilizzato come nome utente il tuo nome su facebook, continuare?
          </Dialog>

          <div style={styles.bottom}>
            <p style={styles.smallText}>
              Hai dimenticato la password?
              {' '}
              <Link
                to="/password-recover"
                style={{ color: themeColors.positive }}>
                Recupera Password
              </Link>
            </p>
            <p style={styles.smallText}>
              Hai già un account?
              {' '}
              <Link to="/login" style={{ color: themeColors.positive }}>
                Accedi
              </Link>
            </p>
          </div>

        </Paper>
      </form>
    )
  }
}

const selector = formValueSelector('registration-form')

const mapStateToProps = state => ({
  fbData: getFbData(state),
  signUpWith: selector(state, 'signUpWith'),
  username: selector(state, 'username'),
  generatedUsername: selector(state, 'generatedUsername'),
  submitErrors: getFormSubmitErrors('registration-form')(state),
  isValid: isValid('registration-form')(state),
})

export default reduxForm({
  form: 'registration-form',
  validate,
})(
  connect(mapStateToProps, {
    change,
    submit,
    registerField,
    untouch,
    fbLoginAndMe,
    unloadFbLoginAndMe,
  })(RegisterForm)
)



// WEBPACK FOOTER //
// ./src/common/RegisterForm.js